<template>
  <div class='info'>
    <!-- <navigator :title="navtital" :routePath='"/"'></navigator> -->
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">我的</h3>
      <div class="imgbox">
          <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
          <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
        </div>
    </div>
    <div class="blur"></div>
    <div class='card_wrapper'>
      <div class='info_body'>
        <div class="info_top">
          <div>
            <img :src="user.userIcon">
            <h3>{{user.userNick}}</h3>
          </div>
          <p>我的企业</p>
        </div>
        <div class="info_bottom">
          <div @click="tozd">
            <img src="@/static/image/index/me1.png" alt="">
            <h3>账单</h3>
          </div>
          <div @click='todin'>
            <img src="@/static/image/index/me2.png" alt="">
            <h3>发票</h3>
          </div>
          <router-link tag="div" :to="`/propertyDetiles/${commonService.xuncar}`">
            <img src="@/static/image/index/me3.png" alt="">
            <h3>车卡续费</h3>
          </router-link>
        </div>
        <!-- <p class='name paddingL'>{{userCardInfo.name}} &nbsp;</p>
        <p class='mobile paddingL'>{{userCardInfo.phone}} &nbsp;</p>

        <div class='position line'>{{userCardInfo.corpName}} &nbsp;</div>

        <p class='tel paddingL'>TEL: {{userCardInfo.tel}}</p>
        <p class='email paddingL'>Email: {{userCardInfo.email}}</p>
        <p class='address paddingL'>ADDR: {{userCardInfo.address}}</p> -->
      </div>
    </div>
    <div class="abox">
        <mt-cell class='info_link link_cell' title="个人中心" to="/personal/editInfo" is-link>
          <i slot='icon' class='iconfont icon-gerenmingpian'></i>
        </mt-cell>
        <mt-cell class='info_link link_cell' title="订单管理" to="/personal/propertyList" is-link>
          <i slot='icon' class='iconfont icon-dingdanzhongxin'></i>
        </mt-cell>
        <mt-cell class='info_link link_cell' title="物业查询" to="/personal/Pay" is-link>
          <i slot='icon' class='iconfont icon-qiugouhezuo'></i>
          <!-- <span v-show="qirow>0" class="feiy">欠费:({{tolt}})</span> -->
        </mt-cell>
        <mt-cell class='info_link link_cell' title="账户管理" to="/personal/editCard" is-link>
          <i slot='icon' class='iconfont icon-zhaopeixun'></i>
        </mt-cell>
        <mt-cell class='info_link link_cell' title="发票管理" to="/personal/invoice" is-link>
          <i slot='icon' class='iconfont icon-caidan'></i>
        </mt-cell>
        <mt-cell class='order_link link_cell' title="历史消息" to="/personal/News" is-link>
          <i slot='icon' class='iconfont icon-dingdanzhongxin'></i>
        </mt-cell>
    </div>
    <!--<mt-cell class='right_cell' title="园区用户专属特权"></mt-cell>-->

    <!--<ul class='rights'>-->
      <!--<li class='item' @click='rightDetail(1)'>-->
        <!--<div class="icon"><i class='iconfont icon-VIPquanyi'></i></div>-->
        <!--<p>VIP权益</p>-->
      <!--</li>-->
      <!--<li class='item' @click='rightDetail(2)'>-->
        <!--<div class="icon"><i class='iconfont icon-zhuanshufuli'></i></div>-->
        <!--<p>专享福利</p>-->
      <!--</li>-->
      <!--<li class='item' @click='rightDetail(3)'>-->
        <!--<div class="icon"><i class='iconfont icon-huoqurenmai'></i></div>-->
        <!--<p>获取人脉</p>-->
      <!--</li>-->
    <!--</ul>-->
    <div>
      <van-tabbar v-model="active">
        <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
        <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
        <van-tabbar-item :to="`${this.currentParkId == 1003||this.currentParkId == 1000||this.currentParkId == 1006?'/parkCompleteSet/foodCourt':'/humanResource/jobList'}`"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
        <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
        <van-tabbar-item to="/personal"><div class="divicon mydian"><van-icon size='22px' name="contact" />我的<span v-show="qirow>0" class="redd"></span></div></van-tabbar-item>
      </van-tabbar>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import commonService from '@/static/commonService';

export default {
  data() {
    return {
      active: 4,
      navtital: '个人中心',
      userCardInfo: {},
      user: {},
      qirow:0,
      tolt:0,
      commonService: {},
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    };
  },
  methods: {
    toEdit() {
      this.$router.push(`/personal/editCard`);
    },
    tozd() {
      this.$router.push(`/personal/Bill`);
    },
    todin() {
      this.$router.push(`/personal/addinvoice`);
    },
    tocar() {
      this.$router.push(`/propertyDetiles/1066`);
    },
    getUserInfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, {
        headers: {
          token: this.token,
        },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.userCardInfo = res.resData.userCardInfo;
          this.user = res.resData;
        }
      });
    },
    getarrears() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/arrears`, {
        parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.qirow = parseInt(res.resData.total);
          this.tolt = res.resData.total.toFixed(2);
        }
      });
    },

    rightDetail(serviceId) {
      this.$router.push(`/personal/rightDetail/${serviceId}`);
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {

        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId']),
  },
  created() {
    if (!this.token) {
      this.$root.eventHub.$emit('login', this.$route.fullPath);
    } else {
      this.getUserInfo();
      // this.getarrears();
    }
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
  },
};
</script>


<style lang="scss" scoped>
@import '~@scss';
.info{
  background: rgb(245, 245, 245);
  .card{
    border-bottom: .013333rem solid rgb(245, 245, 245);
  }
  .divicon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      padding-bottom: .1rem;
    }
  }
  .mydian{
    position: relative;
    .redd{
      width:7px;
      height: 7px;
      border-radius: 50%;
      position: absolute;
      top: 0px;
      right: 0px;
      background: #eb3047;
    }
}
.feiy{
  margin-right: 6px;
  color: #ab071c;
}
  .onehome{
    background: #205eff;
    width: 100%;
    height: 1.2rem;
    display: flex;
    justify-content:space-between;
    align-items: center;
    .return{
      padding-left: .18rem;
    }
    .title{
      text-align: center;
      color: #fff;
      padding-left: .88rem;
    }
    .imgbox{
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: .18rem;
    }
  }
  .blur{
    background: #205eff;
    height: 3.2rem;
  }
  .card_wrapper{
    padding: .2rem .58rem;
    margin-bottom: .133333rem;
    margin-top: -2.8rem;
    .info_body{
      padding: .4rem 0;
      box-shadow: 0 .026667rem .053333rem .066667rem rgba(0, 0, 0, 0.1);
      color: rgb(81, 81, 81);
      font-size: .213333rem;
      background: #fff;
      border-radius: .2rem;
      .info_top{
        height: 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 .56rem;
        div{
         display: flex;
         align-items: center;
         img{
           margin-right: .2rem;
           width: 1.6rem;
           height: 1.6rem;
         }
        }
        p{
          background: #205eff;
          padding: .12rem;
          border-radius: .2rem;
          font-size: .28rem;
          color: #fff;
        }
      }
      .info_bottom{
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: .62rem;
        div{
          display: flex;
          justify-content: center;
          align-items: center;
          // flex-wrap: wrap;
          flex-direction:column; 
          img{
            width: 1.68rem;
            margin-bottom: .1rem;
          }
        }
      }
      .paddingL{
        padding-left: .96rem;
        margin: .213333rem 0;
        height: .426667rem;
        line-height: .426667rem;
        &.name{
          height: .64rem;
          line-height: .64rem;
          font-size: .4rem;
          font-weight: 700;
        }
        &.mobile{
          height: .533333rem;
          line-height: .533333rem;
          font-size: .24rem;
          font-weight: 600;
        }
      }
      .line{
        padding-left: .96rem;
        height: .8rem;
        line-height: .8rem;
        background: $color-main;
        color: #fff;
        font-size: .266667rem;
      }

    }
  }
  .abox{
    padding: 0 0.58rem;
    // height: 9rem;
    padding-bottom: 1.8rem;
    a:nth-child(1){
      border-radius: .2rem .2rem 0 0;
    }
    a:nth-last-child(1){
      border-radius:  0 0 .2rem .2rem;
    }
  }
  .link_cell{
    height: 1.173333rem;
    line-height: 1.173333rem;
    font-size: .4rem;
    color: rgb(81, 81, 81);
    &.info_link{
      border-bottom: .013333rem solid rgb(245, 245, 245);
    }
    &.order_link{
      margin-bottom: .133333rem;
      i{
        color: rgb(191, 229, 204);
      }
    }
    .iconfont{
      font-size: .4rem;
    }
    .icon-gerenmingpian{
      color: rgb(255, 102, 102);
    }
    .icon-zhaopeixun{
      color: #ee35e8;
    }
    .icon-qiugouhezuo{
      color: #205eff;
    }
    .icon-caidan{
      color: #89479b
    }
    .icon-dingdanzhongxin{
      color: rgb(245, 166, 35);
    }
  }

  .right_cell{
    height: 1.173333rem;
    line-height: 1.173333rem;
    font-size: .4rem;
    color: rgb(81, 81, 81);
    border-bottom: .013333rem solid rgb(245, 245, 245);
  }

  .rights{
    display: flex;
    padding: .853333rem;
    background: #fff;
    .item{
      flex: 1 1 auto;
      text-align: center;
      color: rgb(103, 103, 103);
      font-size: .4rem;
      font-weight: 600;
      .iconfont{
        font-size: 1.013333rem;
        margin-bottom: .266667rem;
        &.icon-VIPquanyi{
          color: rgb(255, 121, 78);
        }
        &.icon-zhuanshufuli{
          color: rgb(255, 108, 107);
        }
        &.icon-huoqurenmai{
          color: rgb(107, 177, 255);
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/UserIndex.vue